import React, { useState } from 'react';
import Header from './../components/Header';
import Footer from './../components/Footer';
import { useLocation } from 'react-router-dom';
import Stripe from '../components/Stripe';
import { useCurrency } from '../context/CurrencyContext';
import api from '../api/api';

const Payment = () => {
    const { state: { price, items, orderId } } = useLocation();
    const [paymentMethod, setPaymentMethod] = useState('stripe');
    const [orderPlaced, setOrderPlaced] = useState(false);
    const { formatBase, currency } = useCurrency();

    const handleCOD = async () => {
        try {
            await api.post('/order/confirm-cod', { orderId });
        } catch (error) {
            console.log(error?.response?.data || error.message);
        }
        setOrderPlaced(true);
    };

    return (
        <div>
            <Header />
            <section className='bg-[#eeeeee]'>
                <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16 mt-4 '>
                    {
                        orderPlaced ? (
                            // ✅ Success message like Flipkart
                            <div className="flex flex-col justify-center items-center bg-white p-10 rounded-md shadow-md">
                                <img 
                                    src="https://cdn-icons-png.flaticon.com/512/845/845646.png" 
                                    alt="success" 
                                    className="w-20 mb-4"
                                />
                                <h2 className="text-2xl font-semibold text-green-600">Order Placed Successfully!</h2>
                                <p className="text-gray-600 mt-2">Your COD order <b>#{orderId}</b> has been placed.</p>
                                <p className="text-gray-500">We will deliver your items soon.</p>
                                <button 
                                    onClick={() => window.location.href = '/'} 
                                    className="mt-6 px-6 py-2 bg-[#059473] text-white rounded shadow hover:shadow-lg"
                                >
                                    Continue Shopping
                                </button>
                            </div>
                        ) : (
                            <div className='flex flex-wrap md:flex-col-reverse'>
                                <div className='w-7/12 md:w-full'>
                                    <div className='pr-2 md:pr-0'>
                                        <div className='flex flex-wrap'>
                                            <div
                                                onClick={() => setPaymentMethod('stripe')}
                                                className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'stripe' ? 'bg-white':'bg-slate-100'}`}
                                            >
                                                <div className='flex flex-col gap-[3px] justify-center items-center'>
                                                    <img src="/images/payment/stripe.png" alt="" />
                                                </div>
                                                <span className='text-slate-600'>Stripe</span>
                                            </div>

                                            <div
                                                onClick={() => setPaymentMethod('cod')}
                                                className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'cod' ? 'bg-white':'bg-slate-100'}`}
                                            >
                                                <div className='flex flex-col gap-[3px] justify-center items-center'>
                                                    <img src="/images/payment/cod.jpg" alt="" />
                                                </div>
                                                <span className='text-slate-600'>COD</span>
                                            </div>
                                        </div> 
                                        
                                        {paymentMethod === 'stripe' && (
                                            <div>
                                                <Stripe orderId={orderId} price={price} currency={currency} /> 
                                            </div>
                                        )}

                                        {paymentMethod === 'cod' && (
                                            <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                                <button 
                                                    onClick={handleCOD}
                                                    className='px-10 py-[6px] rounded-sm hover:shadow-green-500/20 hover:shadow-lg bg-[#059473] text-white'
                                                >
                                                    Place Order
                                                </button>
                                            </div>
                                        )}
                                    </div> 
                                </div> 

                                <div className='w-5/12 md:w-full'>
                                    <div className='pl-2 md:pl-0 md:mb-0'>
                                        <div className='bg-white shadow p-5 text-slate-600 flex flex-col gap-3'>
                                            <h2 className='font-bold text-lg'>Order Summary</h2>
                                            <div className='flex justify-between items-center'>
                                                <span>{items} Items and Shipping Fee Included </span>
                                                <span>{formatBase(price)}</span>
                                            </div>
                                            <div className='flex justify-between items-center font-semibold'>
                                                <span>Total Amount</span>
                                                <span className='text-lg text-green-600'>{formatBase(price)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Payment;
